import { Check, ShoppingCart, CreditCard, Beef, HeartHandshake, FileText, Home, Globe, Heart } from "lucide-react";
import type { LucideIcon } from "lucide-react";

export const HOW_IT_WORKS_STEPS: { icon: LucideIcon; step: string; title: string; desc: string }[] = [
  {
    icon: ShoppingCart,
    step: "01",
    title: "Choose Your Korban",
    desc: "Select distribution type, pick your livestock, and enter the names of Sohibul Korban.",
  },
  {
    icon: CreditCard,
    step: "02",
    title: "Make Payment",
    desc: "Your korban order is confirmed instantly once payment is complete.",
  },
  {
    icon: Beef,
    step: "03",
    title: "Korban Fulfilment",
    desc: "Performed within 3 days of Eid Al-Adha. Certificates provided upon completion.",
  },
  {
    icon: HeartHandshake,
    step: "04",
    title: "Distribution",
    desc: "Meat delivered to you in Singapore, or distributed to communities in need.",
  },
];

export const MOCK_TRACKER_STEPS: { icon: LucideIcon; title: string; date: string; done: boolean; upNext?: boolean }[] = [
  { icon: Check, title: "Order Confirmed", date: "27 April 2026", done: true },
  { icon: Beef, title: "Korban Fulfilment", date: "27 May 2026", done: true },
  { icon: FileText, title: "Certificate Issued", date: "28 May 2026", done: true },
  { icon: HeartHandshake, title: "Meat Delivered", date: "Pending", done: false, upNext: true },
];

export const TRACKING_FEATURES = [
  "Status updates delivered to your inbox",
  "Shareable tracking page to keep your family informed",
  "View and download your Korban certificate and photos",
];

// Section copy — shared between mobile and desktop
export const SECTION_COPY = {
  howItWorks: {
    label: "Simple & Seamless",
    title: "How It Works",
    desc: "Order your Korban in minutes. We'll handle the rest from fulfilment to distribution.",
  },
  tracker: {
    label: "Peace of Mind",
    title: "Track Your Korban Status Anytime",
    desc: "Every order comes with a unique tracking page — check in anytime to see exactly where your Korban is at.",
  },
  distribution: {
    label: "Flexible Options",
    title: "Choose How Your Korban Is Distributed",
    desc: "Whether you want meat delivered home or given to those who need it most — the choice is yours.",
  },
  faq: {
    label: "Got Questions?",
    title: "Frequently Asked Questions",
  },
};

export const DISTRIBUTION_OPTIONS: { id: string; icon: LucideIcon; title: string; shortDesc: string; desc: string; highlight: string }[] = [
  {
    id: "local",
    icon: Globe,
    title: "Distribute in Country of Korban",
    shortDesc: "All meat distributed to communities in need locally",
    desc: "All meat is distributed to the communities in need in the country where your Korban is performed.",
    highlight: "100% given to the needy",
  },
  {
    id: "palestine",
    icon: Heart,
    title: "Distribute to Palestine",
    shortDesc: "Distributed to Palestinian families & refugees",
    desc: "Support Palestinian families with your Korban. Distributed via our partner in Jordan to Palestinians in Gaza, West Bank, and refugee communities.",
    highlight: "Direct humanitarian aid",
  },
  {
    id: "delivered",
    icon: Home,
    title: "Receive meat in Singapore",
    shortDesc: "Korban meat delivered to your doorstep in Singapore",
    desc: "Fresh Korban meat delivered to your doorstep in Singapore. Perfect for families who want to celebrate with their own share.",
    highlight: "Meat delivered to you",
  },
];
